/**
 * パートナー情報にアクセスするためのロジック群
 * localStprageへのアクセスはこのmodule内に制限する
 */
export default {
  getCurrentUserId: profile => {
    let selectedPartner = localStorage.getItem('selectedPartner');

    // localStorageのuserIdがpartnerListの中にあるか確認する
    if (selectedPartner &&
        profile.partnerList &&
        Object.values(profile.partnerList).filter(userId => userId === selectedPartner).length > 0) {
      return selectedPartner;
    }

    localStorage.removeItem('selectedPartner');
    return profile.userId;
  },
  setCurrentUserId: userId => {
    localStorage.setItem('selectedPartner', userId);
  },
  setSelectUsers: (profile, partners) => {
    let selectUsers = [];
    selectUsers.push({
      lineId: profile.lineId,
      userId: profile.userId,
      displayName: profile.displayName,
      pictureUrl: profile.pictureUrl,
      isPartner: false,
    });

    if (partners) {
      if (partners.length === 0) {
        localStorage.removeItem('selectedPartner');
      }
      else {
        partners.forEach(partner => {
          selectUsers.push({
            lineId: partner.lineId,
            userId: profile.partnerList[partner.lineId],
            displayName: partner.displayName,
            pictureUrl: partner.pictureUrl,
            isPartner: true,
          });
        });
      }
    }
    else {
      localStorage.removeItem('selectedPartner');
    }

    return selectUsers;
  },
};